<template>
  <div v-if="errors && errors.length" class="errors-box">
    <i v-if="guide" class="el-icon-warning" />
    {{ guide }}
    <ul>
      <li v-for="(error, index) in errors" :key="index">
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ErrorsList',

  props: {
    errorGuide: {
      type: String,
      default: undefined,
    },

    errors: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },

  computed: {
    guide() {
      if (this.errorGuide != null) {
        return this.errorGuide;
      }

      return this.$t('ERRORS_LIST_GUIDE');
    },
  },
};
</script>
<style lang="scss">
.errors-box {
  color: $lb-color-alert;
  font-size: $lb-small-font-size;

  ul {
    margin-top: $global-margin / 2;
  }
}
</style>
